import { Grid, createStyles, makeStyles } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { ROOT } from '../../../constants/routes';
import cn from 'classnames';
import styleRules from './styles';

const space = `${ROOT}/Auth/space.jpg`;
const space2x = `${ROOT}/Auth/space@2x.jpg`;
const space3x = `${ROOT}/Auth/space@3x.jpg`;

const Layout: FunctionComponent = ({ children }) => {
  const useStyles = makeStyles((theme) => createStyles(styleRules(theme)));
  const { circle, imgGrid, right, spacing, root, square } = useStyles();

  return (
    <Grid className={cn(root, spacing)} container wrap="nowrap">
      {children}
      <Grid className={imgGrid} container item sm={12} md={7} xl={7}>
        <Grid className={circle} />
        <Grid className={square} />
        <img className={right} src={space} alt="space" srcSet={`${space2x} 2x, ${space3x} 3x`} />
      </Grid>
    </Grid>
  );
};

export default Layout;
